var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-row',{staticClass:"progress-form"},_vm._l((_vm.items),function(i,k){return _c('v-col',{key:k,attrs:{"cols":"4"}},[_c('div',{staticClass:"progress-form__item"},[_c('p',{staticClass:"caption mb-8",style:({
          textAlign: 'center',

        })},[_vm._v(_vm._s(i.title))]),_c('ProgressCircular',{attrs:{"color":i.color,"value":i.value}})],1)])}),1)}
var staticRenderFns = []

export { render, staticRenderFns }